import { FC, useContext, } from "react";
import { UserContext, TeamContext } from "../../../../context";
import { UploadProfileImage } from "../../../atoms";

const LobbyHeaderUserProfilePicture: FC<{}> = () => {
    const { userData } = useContext(UserContext);
    const { game } = useContext(TeamContext);
    const userColor = game?.players.find((player: any) => { return player.email === userData?.email })?.color || "pink";

    return (
        <div className="user_image">
            <div className="user_image_and_edit_button_wrapper">

                <img
                    id="refreshTheHeaderProfileImage"
                    className={`lobby_user_image border_color_${userColor} `}
                    src={`${process.env.REACT_APP_BACKEND_URL}images/${userData?.email}.png`}
                    alt="Profile Icon"
                />
                    <UploadProfileImage />

            </div>
        </div>
    );
};

export default LobbyHeaderUserProfilePicture;
